import { DateTime, Duration } from 'luxon'

import { SupportedLocale } from '../../constants'
import { FieldDefinition } from '../../definitions/field-definitions'
import { isEmpty } from '../../utils/is'
import { Entity } from '../entity'

export type GenericFieldValue = FieldValue<string | number | Entity[] | DateTime | Duration> | null

export abstract class FieldValue<T> {
  public value: T | undefined
  public isAnyOf?: boolean

  constructor() {
    this.value = undefined
  }

  public abstract mapField(field: unknown, fieldDef: FieldDefinition): void

  /**
   * get string representation of the field
   * @param lang the locale that should be used
   * @param args any additional param that the field may need
   */
  public abstract toStringForView(lang?: SupportedLocale, ...args: unknown[]): string

  public clone(): FieldValue<T> {
    const cloned = Object.create(this) as FieldValue<T>
    Object.assign(cloned, this)
    return cloned
  }

  public isEmpty(): boolean {
    return isEmpty(this.value)
    // return !this.value
  }

  public isEqual(fieldValue: FieldValue<T>) {
    return fieldValue && fieldValue.value == this.value
  }
}
